<template>
  <div>
    <EditEquipment
      :equipmentId="equipmentId"
      :institutionIdProp="institutionId"
    />
  </div>
</template>

<script>
import EditEquipment from '../components/equipment/edit/ManageEquipment.vue'
export default {
  components: {
    EditEquipment,
  },
  data() {
    return {
      equipmentId: null,
      institutionId: null,
    }
  },
  created() {
    this.equipmentId = this.$route.params.equipmentId
    this.institutionId = this.$route.params.institutionId
  },
}
</script>

<style lang="scss" scoped></style>
